import { ActionTypes } from "../constants/action-types";

const initialState = {
    feedback: [],
};

export const FetchFeedback = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.FETCH_FEEDBACK:
      return { ...state, feedback: payload };
    default:
      return state;
  }
};